import React, { useState, useEffect } from "react";
import { Toaster, toast } from "react-hot-toast";
import { showToast } from "../../Helpers/showToast";
import { SUPERGET, SUPERPOST } from '../../Services/AxiosService';
import { HiArrowNarrowRight } from "react-icons/hi";
import { useNavigate, useParams } from "react-router-dom";
import Logo from "../../Images/easytradelogo.png";
import { useDispatch, useSelector } from "react-redux";

import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import axios from "axios";

export default function CodeInput() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [CompanyCode, setCompanyCode] = useState("");
    const { cmpdetail, status, error } = useSelector(
        (state) => state.CompanyDetail
    );

    const [Loader, setLoader] = useState(false);



    const handleSubmit = async () => {
        if (!CompanyCode) {
            showToast("Please fill Code here", "error");
            return;
        }
        setLoader(true);

        try {
            const result = await SUPERGET(`/company/gvtnbcc/${CompanyCode}`);

            if (result.success == true) {
                setLoader(false);
                navigate(`/login/${result?.token}`)
            } else {
                showToast(result?.message || result?.message, "error");
            }
        } catch (error) {
            setLoader(false);
            showToast(error?.message);
        }
    };


    useEffect(() => {
        var compcode = document.getElementById("compcode");

        const keyEnter = (event) => {
            if (event.key === "Enter") {
                event.preventDefault();
                if (event.target.id == "compcode") {
                    handleSubmit();
                } else {
                    compcode.focus();
                }
            }
        };

        document.addEventListener("keydown", keyEnter);

        return () => {
            document.removeEventListener("keydown", keyEnter);
        };
    });


    const login = createTheme({
        palette: {
            primary: {
                main: "#fff",
            },
        },
        typography: {
            fontFamily: "Poppins",
        },
        components: {
            MuiInputBase: {
                styleOverrides: {
                    root: {
                        color: "#fff",
                        height: "50px",
                        padding: "0 5px 0 5px",
                    },
                    input: {
                        '&:-webkit-autofill': {
                            padding: "12px",
                        },
                    },
                },
            },
            MuiInputLabel: {
                styleOverrides: {
                    root: {
                        marginTop: "-4px",
                        padding: "0 5px 0 5px"
                    },
                },
            },
            MuiButton: {
                styleOverrides: {
                    root: {
                        color: "#000",
                        fontSize: "14.5px",
                        fontWeight: 500,
                        height: "45px",
                        borderRadius: "50px"
                    },
                },
            },
        },
    });

    return (
        <>
            <div className="row g-0">
                <div className="col-lg-6 col-md-6 col-sm-12">
                    <div className="login-box-1 border-0 rounded-0 someClass-login p-5">
                        <div className="row">
                            <div className="col-12 m-auto p-5 mt-5">
                                <img src={Logo} className="" style={{ width: "100%" }} />
                                <div className="text-center run-business-text">
                                    Vendor Portal
                                </div>
                                <div
                                    className="text-center"
                                    style={{
                                        color: "#AAA",
                                        fontSize: 12,
                                        fontWeight: 400,
                                        fontFamily: "Poppins",
                                        fontStyle: "normal",
                                        lineHeight: "normal",
                                    }}
                                >
                                    integrated on the cloud!
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-6 col-md-6 col-sm-12">
                    <div className="login-box-2 border-0 rounded-0 someClass py-0">
                        <ThemeProvider theme={login}>
                            <Box
                                sx={{
                                    maxWidth: '400px',
                                    margin: 'auto',
                                    padding: '20px',
                                    // borderRadius: '8px',
                                    // boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
                                }}
                            >
                                <Typography sx={{ color: "#fff", fontSize: "35px", textAlign: "center" }}>Welcome To</Typography>
                                <Typography sx={{ color: "#fff", fontSize: "20px", textAlign: "center" }}>Easy Trade Vendor Login</Typography>
                                <TextField
                                    fullWidth
                                    focused
                                    id="compcode"
                                    label="Company Code"
                                    name="compcode"
                                    value={CompanyCode}
                                    onChange={(e) => setCompanyCode(e.target.value)}
                                    margin="normal"
                                    InputProps={{
                                        style: {
                                            borderRadius: "50px",
                                        }
                                    }}
                                    sx={{ mt: 4 }}
                                />
                                <Button fullWidth type="submit" variant="contained" color="primary" endIcon={<HiArrowNarrowRight />} onClick={handleSubmit} sx={{ mt: 2 }}>
                                    Submit
                                </Button>
                            </Box>
                        </ThemeProvider>
                    </div>
                </div>
            </div>
            <Backdrop
                sx={{
                    color: "#fff",
                    zIndex: (theme) => theme.zIndex.drawer + 1,
                }}
                open={Loader}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
            <Toaster position="top-center" reverseOrder={false} />
        </>
    );
}
